module.exports = __webpack_public_path__ + "static/media/meplaying.761dba1d.jpg";